/* globals dataLayer, angular, __env */
(function (window, angular, undefined) {
    angular.module('formApp')
        .component('wantToPay', {
            templateUrl: 'components/payment-selector/templates/payment-selector.html',
            bindings: {
                ngModel: '<',
                formData: '<',
                eQuote: '<',
                eCoverNote: '<',
            },
            require: { ngModelCtrl: 'ngModel' },
            controller: ['dataUtils', '$filter','formData', 'scrollToPoint', function (dataUtils, $filter,formData, scrollToPoint) {
                var ctrl = this;
                ctrl.setPaymentType = function (pp){
                    //Below commented code is added as part of - charity donation a/b test setup
                    // if (__env && __env.tt_cd2 && (!ctrl.formData.charitableDonation || !ctrl.formData.charitableDonation.wishesToDonate)) {
                    //     ctrl.moveToWishToDonate();
                    // } else {
                        this.ngModelCtrl.$setViewValue(pp);
                    //}

                };

                ctrl.moveToWishToDonate = function (){
                    scrollToPoint.scrollTo('wishToDonate', 20, 'id');
                    this.formData.charitableDonation={hasDonationSelected :"N"};
                };

            }]
        });
})(window, window.angular);